@if (tournamentValidation && tournament) {
  <mat-card appearance="outlined" class="m-3">
    <mat-card-header>
      <h6>Toernooi ({{ getTournamentMatchCount(tournament)}} wedstrijden)</h6>
    </mat-card-header>
    <mat-card-content>
      <mat-expansion-panel [disabled]="tournamentValidation.validations.length == 0">
        <mat-expansion-panel-header>
          <mat-panel-title>
            Validaties&nbsp;<span class="badge {{ Validation.hasErrors(tournamentValidation.validations) ? 'text-bg-danger' : 'text-bg-success'}}">{{ tournamentValidation.validations.length }}</span>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <ul>
          @for (validation of tournamentValidation.validations; track validation) {
            <li>
              <mat-icon class="text-{{ getColorForSeverity(validation.severity) }}">{{ getIconForSeverity(validation.severity) }}</mat-icon>
              {{ validation.message }}
            </li>
          }
        </ul>
      </mat-expansion-panel>
    </mat-card-content>
  </mat-card>
  @for (event of tournament.events; track event.id) {
    <mat-card appearance="outlined" class="m-3">
      <mat-card-header>
        <h6>{{ TournamentEvent.getType(event.type) }} ({{ getEventMatchCount(event)}} wedstrijden)</h6>
      </mat-card-header>
      <mat-card-content>
        <mat-accordion multi="true">
          <mat-expansion-panel [disabled]="event.registrations.length == 0">
            <mat-expansion-panel-header>
              <mat-panel-title>
                Inschrijvingen&nbsp;<span class="badge {{ event.registrations.length == 0 ? 'text-bg-danger' : 'text-bg-success'}}">{{ event.registrations.length }}</span>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <table class="table {{ event.doublesEvent ? 'w-100' : 'w-50' }}">
              <thead class="thead-dark">
              <tr>
                <th scope="col" class="w-25">Naam</th>
                <th scope="col" class="w-25">Club</th>
                @if (event.doublesEvent) {
                  <th scope="col" class="w-25">Partner</th>
                  <th scope="col" class="w-25">Club</th>
                }
              </tr>
              </thead>
              <tbody>
                @for (registration of event.registrations; track registration.id) {
                  <tr>
                    <td class="align-middle">{{ registration.player | fullName }}</td>
                    <td class="align-middle">{{ registration.player.club }}</td>
                    @if (event.doublesEvent) {
                      <td class="align-middle">{{ registration.partner | fullName }}</td>
                      <td class="align-middle">{{ registration.partner?.club }}</td>
                    }
                  </tr>
                }
              </tbody>
            </table>
          </mat-expansion-panel>
          <mat-expansion-panel [disabled]="getEventValidation(event.id)?.validations?.length == 0">
            <mat-expansion-panel-header>
              <mat-panel-title>
                Validaties&nbsp;<span class="badge {{ Validation.hasErrors(getEventValidation(event.id)?.validations) ? 'text-bg-danger' : 'text-bg-success'}}">{{ getEventValidation(event.id)?.validations?.length }}</span>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <ul>
              @for (validation of getEventValidation(event.id)?.validations; track validation) {
                <li>
                  <mat-icon class="text-{{ getColorForSeverity(validation.severity) }}">{{ getIconForSeverity(validation.severity) }}</mat-icon>
                  <player-link [validationMessage]="validation.message"></player-link>
                </li>
              }
            </ul>
          </mat-expansion-panel>
        </mat-accordion>
      </mat-card-content>
    </mat-card>
  }
}
